import isInKwaiying from '../isInKwaiying';
import { envMap } from './base';
import callNative from '../callNative';
import { parse } from 'qs';
const env = process.env.CODE_ENV || process.env.NODE_ENV;
let url = process.env.URL || '';
let laneId = process.env.LANEID || '';
if ((process.env.CODE_ENV || process.env.NODE_ENV) !== 'production') {
    if (window.location.search) {
        const { serverHost, laneId: laneIdFromQuery } = parse(window.location.search.substring(1));
        if (serverHost && !url) {
            url = decodeURIComponent(serverHost);
        }
        if (laneIdFromQuery && !laneId) {
            laneId = laneIdFromQuery;
        }
    }
}
function getDefault() {
    const envConf = envMap[env] ||
        (env === 'development' ? envMap.staging : envMap.production);
    return {
        url: url || envConf.url,
        type: envConf.type,
        debug: 0,
        direct: 0,
        laneId,
    };
}
export default async function () {
    if (isInKwaiying()) {
        return callNative('getInfoFromKwaiYing', {
            params: { infoName: 'envConfig' },
        })
            .then((env) => {
            const res = JSON.parse(env);
            if (res.type === 2) {
                res.url = envMap.production.url;
            }
            return res;
        })
            .catch(() => {
            return getDefault();
        });
    }
    return getDefault();
}
